import ApiService from './ApiService';
import * as queryString from 'query-string';

export default class FeedbackService {
  getPlatformStats() {
    return ApiService.get(`/feedbacks/platform-stats`);
  }

  findAllPublic(query = {}) {
    return ApiService.get(`/feedbacks/public?${queryString.stringify(query)}`, {
      withCredentials: true,
    });
  }

  findAll(query = {}) {
    return ApiService.get(`/feedbacks?${queryString.stringify(query)}`, {
      withCredentials: true,
    });
  }

  create(data) {
    return ApiService.post('/feedbacks', data, {
      withCredentials: true,
    });
  }

  update(id, data) {
    return ApiService.put(`/feedbacks/${id}`, data, {
      withCredentials: true,
    });
  }
}
